<template>
  <Multiselect
    v-model="innerValue"
    :options="options"
    :close-on-select="closeOnSelect"
    :clear-on-select="false"
    :preserve-search="true"
    :label="label"
    :track-by="trackBy"
    :multiple="multiple"
    :placeholder="placeholder"
    select-label="選択"
    selected-label=""
    deselect-label="選択解除"
    no-options=""
    open-direction="bottom"
    :class="classes"
    @open="onOpen"
    @close="onClose"
  >
    <template #noOptions>
      {{ noOptionText }}
    </template>
    <template #selection="{ values, isOpen }">
      <span
        v-if="values.length &amp;&amp; !isOpen"
      >
        {{ placeholder }}
      </span>
    </template>
    <template #option="{ option }">
      <div class="flex flex-col text-xs">
        <div class="truncate text">
          {{ option.text }}
        </div>
        <div>{{ `\xA5${Number(option.sales).toLocaleString()}` }}</div>
      </div>
    </template>
  </Multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'SalesFilter',
  components: {
    Multiselect
  },
  props: {
    label: {
      type: String,
      default: 'text'
    },
    trackBy: {
      type: String,
      default: 'value'
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    modelValue: {
      type: [String, Object, Array],
      default: null
    },
    noOptionText: {
      type: String,
      default: '候補がありません'
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      isClosed: true
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        this.$emit('update:modelValue', newValue)
      }
    },
    classes () {
      return {
        'sales-filter': true,
        'sales-filter--is-closed': this.isClosed
      }
    }
  },
  methods: {
    onOpen () {
      this.isClosed = false
    },
    onClose () {
      this.isClosed = true
    }
  }
}
</script>

<style scoped>
.text {
  max-width: 200px;
}
</style>

<style>
.sales-filter.sales-filter--is-closed .multiselect__tags {
  max-height: 40px;
}
</style>
